export const cheque_status_options = ['dispo','non-dispo']